<template>
    <div class="tnc-wrapper">
        <h2><span style="font-size: 16pt">Termos e Condições</span></h2>

        <h4>
            <strong><span style="font-size: 12pt">Regras gerais</span></strong>
        </h4>

        <ol>
            <li style="list-style-type: decimal; font-size: 10.5pt">
                <p>
                    <span style="font-size: 10.5pt">
                        Nosso site é restrito exclusivamente a indivíduos maiores de idade, conforme determinado pela legislação da jurisdição em que o indivíduo reside.
                    </span>
                </p>
            </li>

            <li style="list-style-type: decimal; font-size: 10.5pt">
                <p>
                    <span style="font-size: 10.5pt">
                        Nosso site não se responsabiliza por quaisquer leis nacionais, federais ou internacionais infringidas por usuários que utilizem nosso site.
                    </span>
                </p>
            </li>

            <li style="list-style-type: decimal; font-size: 10.5pt">
                <p>
                    <span style="font-size: 10.5pt">
                        Os usuários são responsáveis ​​por seus próprios atos e estão sujeitos às leis de seus respectivos países, incluindo leis estaduais e questões legais.
                    </span>
                </p>
            </li>

            <li style="list-style-type: decimal; font-size: 10.5pt">
                <p>
                    <span style="font-size: 10.5pt">
                        Todos os agentes são responsáveis ​​pelas contas de seus respectivos membros e devem honrar todas as apostas confirmadas por eles enviadas.
                    </span>
                </p>
            </li>

            <li style="list-style-type: decimal; font-size: 10.5pt">
                <p>
                    <span style="font-size: 10.5pt">
                        Os agentes não são parceiros do nosso site. Portanto, o nosso site não se responsabiliza por quaisquer discrepâncias ou disputas entre jogadores e agentes.
                    </span>
                </p>
            </li>

            <li style="list-style-type: decimal; font-size: 10.5pt">
                <p>
                    <span style="font-size: 10.5pt">
                        É responsabilidade do usuário proteger seu ID de usuário e senha contra uso não autorizado. Caso o ID de usuário e a senha sejam roubados ou comprometidos, é responsabilidade do usuário contatar seu agente imediatamente. O agente, então, alterará o ID de usuário e a senha para o usuário.
                    </span>
                </p>
            </li>

            <li style="list-style-type: decimal; font-size: 10.5pt">
                <p>
                    <span style="font-size: 10.5pt">
                        Em caso de roubo de ID de usuário e senha, o usuário é responsável por suas respectivas contas e deverá honrar todas as apostas confirmadas.
                    </span>
                </p>
            </li>
        </ol>

        <h4>
            <strong><span style="font-size: 12pt">Regras do Jogo</span></strong>
        </h4>

        <ol>
            <li style="list-style-type: decimal; font-size: 10.5pt">
                <p>
                    <span style="font-size: 10.5pt">
                        Os resultados dos jogos definidos pelo nosso site serão finais e vinculativos.
                    </span>
                </p>
            </li>

            <li style="list-style-type: decimal; font-size: 10.5pt">
                <p>
                    <span style="font-size: 10.5pt">
                        Em todos os casos de disputa, tanto a administração do nosso site quanto o jogador devem concordar que o banco de dados de registro de transações do nosso site servirá como árbitro final na disputa. Todas as disputas devem ser registradas no mesmo dia em que o resultado da partida for determinado. Nenhuma reclamação será aceita após o dia da partida.
                    </span>
                </p>
            </li>

            <li style="list-style-type: decimal; font-size: 10.5pt">
                <p>
                    <span style="font-size: 10.5pt">
                        O jogador é o único responsável por verificar a exatidão de todas as transações de sua conta.
                    </span>
                </p>
            </li>

            <li style="list-style-type: decimal; font-size: 10.5pt">
                <p>
                    <span style="font-size: 10.5pt">
                        Por favor, revise suas apostas cuidadosamente para verificar se há erros, enganos ou omissões antes de enviá-las pelo computador. Uma vez que uma aposta é aceita pelo computador, ela não pode ser alterada ou cancelada.
                    </span>
                </p>
            </li>

            <li style="list-style-type: decimal; font-size: 10.5pt">
                <p>
                    <span style="font-size: 10.5pt">
                        Reservamo-nos o direito de congelar ou cancelar a conta de qualquer cliente que viole estes Termos e Condições, se envolva em atividades fraudulentas, invasão de propriedade, agressão, falsificação, corrupção das regras padrão ou participação em apostas em grupo, sendo todos os saldos resultantes da conta congelados e confiscados sem aviso prévio.
                    </span>
                </p>
            </li>

            <li style="list-style-type: decimal; font-size: 10.5pt">
                <p>
                    <span style="font-size: 10.5pt">
                        Reservamo-nos o direito de anular ou cancelar qualquer aposta ou bilhete que esteja associado a apostas em grupo, apostas coordenadas, conluio, fraude, abuso do sistema, exploração de erros técnicos, probabilidades incorretas ou qualquer outra tentativa de obter vantagem injusta. Quaisquer ganhos relacionados poderão ser estornados e a conta correspondente poderá ser suspensa ou encerrada.
                    </span>
                </p>
            </li>
        </ol>

        <h4>
            <strong><span style="font-size: 12pt">Limites e responsabilidades</span></strong>
        </h4>

        <ol>
            <li style="list-style-type: decimal; font-size: 10.5pt">
                <p>
                    <span style="font-size: 10.5pt">
                        Sem prejuízo da generalidade do exposto, o nosso website não será responsável perante qualquer pessoa em caso de sabotagem, força maior e/ou por eventos de falha, dano ou destruição do sistema informático central ou dos registos do nosso website, ou de qualquer parte dos mesmos, ou por atrasos, perdas, erros, omissões ou quaisquer outros resultantes de falhas em qualquer sistema de telecomunicações ou de transmissão de dados, ou por qualquer atraso que resulte na não receção de qualquer inscrição para uma determinada corrida.
                    </span>
                </p>
            </li>

            <li style="list-style-type: decimal; font-size: 10.5pt">
                <p>
                    <span style="font-size: 10.5pt">
                        Nosso site não será responsabilizado por quaisquer perdas resultantes de casos fortuitos ou de força maior, como conflitos armados, motins, distúrbios civis, atos de terrorismo, atos governamentais ou de autoridades (incluindo a recusa ou revogação de qualquer licença ou autorização), incêndios, explosões, inundações, roubos, danos dolosos, greves, bloqueios e ações industriais de qualquer tipo.
                    </span>
                </p>
            </li>

            <li style="list-style-type: decimal; font-size: 10.5pt">
                <p>
                    <span style="font-size: 10.5pt">
                        Em caso de falhas de conexão de rede, comunicação, sistema ou erros humanos que causem problemas relacionados a apostas, como apostas duplas aceitas, apostas não confirmadas, apostas feitas após o início do jogo, etc., reservamo-nos o direito de analisar cada caso individualmente e tomar as medidas necessárias para corrigi-los. Não nos responsabilizamos perante você ou terceiros por tais erros. Se você tiver sofrido esses erros e continuar apostando sem informar seu patrocinador, você será responsabilizado e terá que arcar com todos os resultados de ganhos/perdas caso os erros ocorram novamente.
                    </span>
                </p>
            </li>

            <li style="list-style-type: decimal; font-size: 10.5pt">
                <p>
                    <span style="font-size: 10.5pt">
                        Estas Regras e Regulamentos constituem o acordo e entendimento integral entre as partes.
                    </span>
                </p>
            </li>

            <li style="list-style-type: decimal; font-size: 10.5pt">
                <p>
                    <span style="font-size: 10.5pt">
                        Caso haja alguma discrepância entre a versão em inglês destas Regras e Regulamentos e qualquer outra versão em outro idioma, a versão em inglês prevalecerá sobre as demais e será considerada correta e válida.
                    </span>
                </p>
            </li>
        </ol>

        <BurgerMenu v-if="isMobile" />
    </div>
</template>
<script>
  import BurgerMenu from '@/components/burger-menu.vue';
  import { isMobile } from 'mobile-device-detect';
  export default {
    components: {
      BurgerMenu,
    },
    data: () => {
      return {
        isMobile,
      };
    },
  };
</script>
<style lang="scss" scoped>
  .tnc-wrapper {
    padding: 16px 24px;
    box-sizing: border-box;
    height: calc(100% - 56px);
    overflow-y: auto;
  }

  strong,
  h2,
  h4 {
    font-weight: 600;
  }
</style>